export default __webpack_public_path__ + "static/media/main.5f21768e.png";